import React from 'react';
import HomePage from '../components/reusable/HomePage/HomePage.js';
import AboutUs from '../view/pages/AboutUs/AboutUs.js';
import FacilitiesPage2 from '../view/pages/FacilitiesPage2/FacilitiesPage2.js';
import Service from '../view/pages/OurServices/Service/Service.js';
import FacilitiesPage from '../view/pages/WhoWeHelp/FacilitiesPage/FacilitiesPage.js';
import PatientsAndFamilies from '../view/pages/WhoWeHelp/PatientsAndFamilies/PatientsAndFamilies.js';
import CareersAndCulture from '../view/pages/Community/CareersAndCulture/CareersAndCulture.js';
import MeetOurTeam from '../view/pages/Community/MeetOurTeam/MeetOurTeam.js';
import FounderTeamPage from '../view/pages/Community/MeetOurTeam/SubMeetOurTeamPages/FounderTeamPage/FounderTeamPage.js';
import StrategicTeamPage from '../view/pages/Community/MeetOurTeam/SubMeetOurTeamPages/StrategicTeamPage/StrategicTeamPage.js';
import ClinicalTeamPage from '../view/pages/Community/MeetOurTeam/SubMeetOurTeamPages/ClinicalTeamPage/ClinicalTeamPage.js';
import TeamMemberDetails from '../view/pages/Community/MeetOurTeam/SubMeetOurTeamPages/TeamMemberDetails/TeamMemberDetails.js';
import EngineeringTeam from '../view/pages/Community/MeetOurTeam/SubMeetOurTeamPages/EngineeringTeam/EngineeringTeam.js';
import AcuteCareHospitals from '../view/pages/WhoWeHelp/AcuteCareHospitals/AcuteCareHospitals.js';
import InpatientRehabFacilities from '../view/pages/WhoWeHelp/InpatientRehabFacilities/InpatientRehabFacilities.js';
import ContactPage from '../view/pages/ContactPage/ContactPage.js';
import PageForJobApply from '../view/pages/PageForJobApply/PageForJobApply.js';

const getRoutes = () => [
    {
        path: '/',
        element: <HomePage />,
    },
    {
        path: '/home',
        element: <HomePage />,
    },
    // {
    //     path: '/facilities-page',
    //     element: <FacilitiesPage2 />,
    // },
    {
        path: '/about',
        element: <AboutUs />,
    },
    {
        path: '/contact-us',
        element: <ContactPage />,
    },
    {
        path: '/service',
        element: <Service />,
    },
    {
        path: '/acute-care-hospitals-page',
        element: <AcuteCareHospitals />,
    },
    {
        path: '/inpatient-rehab-facilities-page',
        element: <InpatientRehabFacilities />,
    },
    {
        path: '/facilities-page',
        element: <FacilitiesPage />,
    },
    {
        path: '/patients-and-families',
        element: <PatientsAndFamilies />,
    },
    {
        path: '/careers-and-culture',
        element: <CareersAndCulture />,
    },
    {
        path: '/page-for-job-apply',
        element: <PageForJobApply />,
    },
    {
        path: '/meet-our-team',
        element: <MeetOurTeam />,
    },
    {
        path: '/founder',
        element: <FounderTeamPage />,
    },
    {
        path: '/business-strategic-ops',
        element: <StrategicTeamPage />,
    },
    {
        path: '/clinical-team',
        element: <ClinicalTeamPage />,
    },
    {
        path: '/engineer-team',
        element: <EngineeringTeam />,
    },
    {
        path: '/team-member-details',
        element: <TeamMemberDetails />,
    },
];

export default getRoutes;
